import {markExpectingClose, triggerReconnectStatus} from './connectionMonitor';

let socket = null;

// Последнее делегирование работы бота вместе с доставившим его сокетом (см.
// getLastBotWorkDelegation). Годно, только пока этот сокет текущий: новый
// сокет или выход из матча его сбрасывают
let lastBotWorkDelegation = null;

export const setNetworkSocket = (ws) => {
  socket = ws;
  if (lastBotWorkDelegation && lastBotWorkDelegation.socket !== ws) {
    lastBotWorkDelegation = null;
  }
};

export const getNetworkSocket = () => socket;

export const closeNetworkSocket = () => {
  lastBotWorkDelegation = null;
  if (socket) {
    markExpectingClose();
    // Явное закрытие (выход из матча, конец игры и т.п.) отменяет любой
    // отображаемый индикатор автопереподключения — ждать больше нечего
    triggerReconnectStatus(null);
    socket.close();
    socket = null;
  }
};

/**
 * Отправка сообщения матчевому сокету. Возвращает, ушло ли сообщение: закрытый
 * или еще не открытый сокет — не ошибка, вызывающий код просто попробует позже.
 */
export const sendNetworkMessage = (message) => {
  if (!socket || socket.readyState !== WebSocket.OPEN) return false;
  try {
    socket.send(JSON.stringify(message));
    return true;
  } catch (e) {
    console.error('[networkSocket] send failed', e);
    return false;
  }
};

// Подписчики на сообщения матчевого сокета.
//
// Раньше желающие послушать трафик (GameContent — конец матча, OnlineBotRunner —
// делегирование ботов) подменяли ws.onmessage, запоминая предыдущий обработчик
// и возвращая его при отписке. Двое таких подписчиков на один слот — уже
// лотерея: порядок монтирования и переустановок после реконнекта определял,
// чья обертка выживет, а неудачное сочетание оставляло цепочку без основного
// обработчика — экшены переставали применяться при живом сокете.
//
// Здесь подписчики независимы, порядок отписки ничего не ломает, и подписка не
// привязана к конкретному объекту сокета — переустанавливать ее после
// переподключения не нужно.
const messageSubscribers = new Set();

/**
 * @param {(msg: Object, socket: WebSocket|null) => void} subscriber - получает
 * уже разобранное сообщение и сокет, по которому оно пришло
 * @returns {() => void} функция отписки (годится как return из useEffect)
 */
export const addNetworkMessageSubscriber = (subscriber) => {
  messageSubscribers.add(subscriber);
  return () => messageSubscribers.delete(subscriber);
};

/**
 * Последнее делегирование работы бота {payload, socket} — для исполнителя,
 * подписавшегося позже, чем оно пришло (см. OnlineBotRunner). Сервер шлет
 * DELEGATE_BOT_WORK однократно, а на свежей странице экран матча с
 * исполнителем появляется уже после LOAD_STATE, вслед за которым работа и
 * приходит, — без памяти она ушла бы в пустоту, и ход бота встал бы (делегат
 * для сервера жив, повторно работу он не выдает). Отозванная работа
 * (REVOKE_BOT_WORK с тем же ключом) отсюда убирается. Годна ли работа — тот ли
 * сокет, открыт ли он, актуален ли ключ — решает сам исполнитель
 * (delegatedBotWork)
 */
export const getLastBotWorkDelegation = () => lastBotWorkDelegation;

const rememberBotWorkDelegation = (msg, sourceSocket) => {
  if (msg?.type === 'DELEGATE_BOT_WORK' && msg.payload?.workKey) {
    lastBotWorkDelegation = {payload: msg.payload, socket: sourceSocket};
  } else if (msg?.type === 'REVOKE_BOT_WORK' && lastBotWorkDelegation
    && lastBotWorkDelegation.payload.workKey === msg.payload?.workKey) {
    lastBotWorkDelegation = null;
  }
};

/**
 * Раздать сообщение подписчикам. Зовет владелец сокета (LobbyPage) на каждое
 * входящее сообщение и передает сокет, по которому оно пришло: работа бота
 * привязывается к доставившему ее соединению (см. delegatedBotWork).
 * Исключение у одного подписчика не должно мешать ни остальным, ни основной
 * обработке сообщения.
 */
export const notifyNetworkMessageSubscribers = (msg, sourceSocket = socket) => {
  rememberBotWorkDelegation(msg, sourceSocket);
  messageSubscribers.forEach((subscriber) => {
    try {
      subscriber(msg, sourceSocket);
    } catch (e) {
      console.error('[networkSocket] message subscriber failed', e);
    }
  });
};
